import defaultOptions from '@atlassian/jira-common-constants/src/fetch-default-options';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { RequestSecurityRequestBody, SecuritySettingsResponse } from '../../types';

export const getUrl = (projectKey: ProjectKey) =>
	`/rest/servicedesk/1/servicedesk/${projectKey}/settings/requestsecurity`;

export const postRequestSecurity = async (
	projectKey: ProjectKey,
	payload: RequestSecurityRequestBody,
): Promise<SecuritySettingsResponse> => {
	const url = getUrl(projectKey);
	const response = await fetch(url, {
		...defaultOptions,
		method: 'POST',
		body: JSON.stringify(payload),
	});

	if (response.ok) {
		return response.json();
	}
	throw new FetchError(response.status, await response.text());
};
